import React from "react";
import Header from "../components/Header";
import BlogDetails from "../components/BlogDetails";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";

const Blog = () => {
  return (
    <>
    <section
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('https://www.glride.com/wp-content/uploads/2025/08/premium-global-corporate-transportation-solutions.webp')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Blogs
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green transition-colors">Home</a>
            <span className="text-gray-300">-</span>
            <span className="text-logo-green">Blogs</span>
          </div>
        </div>
      </div>
    </section>
    
    <BlogDetails/>
    <FAQ/>
    <Footer/>
    </>
  );
};

export default Blog;







